module.exports = __webpack_public_path__ + "img/icon-generic-generic1.49618ce3.svg";